// Auto-generated page descriptions - Korean
export default {
  arena: {
    mission: `<b>[페이지 설명]</b>
아레나 미션을 관리하는 페이지입니다.
미션 목록 조회, 추가, 수정, 삭제가 가능하며 SmartEditor로 본문을 작성합니다.
이미지는 TUS 프로토콜로 업로드됩니다.

<b>[Column Description]</b>
code :              미션 코드 (고유번호)
description :       미션 설명
postingtime :       게시 일시
deadline :          마감 일시
livetime :          라이브 일시
missiontype :       미션 타입
buttoncount :       버튼 수
prize :             상금 (ARENA)
prize_metaq :       상금 (METAQ)
entry_fee :         참가비
limited :           최대 참가자 수
required metaq :    참가 필요 METAQ
engagement :        현재 참여 수 (참여자 목록 복사 가능)
status :            상태 (0: 비활성, 1: 활성)
edit / delete :     수정 / 삭제 버튼`,
    tokens: `<b>[사용 방법]</b>
1. CSV 파일 업로드 또는 수동 입력(Address, Amount)으로 아레나 토큰 배분 목록을 등록합니다.
2. Upload 버튼 클릭 시 Round, Description을 입력하는 대화상자가 표시됩니다.
3. Send 버튼으로 등록된 목록을 일괄 배분 요청합니다.

<b>[Column Description]</b>
Sequential : 순번 (자동 생성)
Address :    수신 지갑 주소 (유효한 EVM 주소 필수)
Amount :     배분할 아레나 토큰 수량

<b>[File Upload Format]</b>
CSV 파일 (구분자: 콤마), 헤더 없이 데이터만 입력
# Receiving Address, Amount
0x0645Af43088813C44399B79FF45896D68eB23b8F, 100
0x32a4598fCB7272C022557B28dFb8021b6df53F55, 100

<b>[Registration Dialog]</b>
Round :       배분 회차 번호 (마지막 회차 + 1 자동 설정)
Description : 배분 설명 (예: "미션 보상", "이벤트 보상")

<b>[주의사항]</b>
* 주소가 유효한 EVM 주소가 아니면 경고 후 무시됩니다.
* Amount가 숫자가 아닌 경우 경고 후 무시됩니다.`,
    tokensHistory: `<b>[페이지 설명]</b>
아레나 토큰(ARENA) 지급/차감 이력을 조회하는 페이지입니다.
CSV 다운로드 기능을 제공하며, 총 지급량(Total)을 상단에 표시합니다.

<b>[Column Description]</b>
Round :         라운드 번호 (times)
Sequential :    순번 (idx)
Address :       지갑 주소
ARENA :         지급/차감 수량
Description :   사유
Created Date :  생성 일시`,
  },
  erc1155: {
    erc1155Holder: `<b>[페이지 설명]</b>
ERC-1155 토큰 홀더(보유자) 목록을 조회하는 페이지입니다.
각 주소별 보유 수량을 확인할 수 있으며, 정렬/검색/CSV 다운로드 기능을 제공합니다.

<b>[Column Description]</b>
Address :  토큰 보유자 지갑 주소 (Explorer 링크 제공)
Quantity : 해당 주소가 보유한 ERC-1155 토큰 수량

<b>[기능]</b>
* 검색어로 주소 필터링
* 컬럼 정렬 (Address, Quantity)
* CSV 다운로드 (전체 홀더 목록, 진행률 표시)
* Total 표시: 전체 토큰 보유 수량 합계`,
    erc1155Inventory: `<b>[페이지 설명]</b>
ERC-1155 NFT 인벤토리(소유 현황) 페이지입니다.
각 토큰의 메타데이터(이미지, 이름, 설명, 속성)를 조회합니다.

<b>[Column Description]</b>
Token ID :    NFT 토큰 ID (ERC-1155는 동일 ID로 다수 발행 가능)
Image :       NFT 이미지 (클릭 시 Explorer 또는 IPFS 링크로 이동)
Name :        NFT 이름
Description : NFT 설명
Attributes :  NFT 속성 (trait_type:value 형식)

<b>[기능]</b>
* 검색어로 인벤토리 필터링
* CSV 다운로드 (전체 인벤토리, 진행률 표시)
* 이미지 클릭 시 Etherscan NFT 페이지 또는 IPFS 이미지 열기`,
    erc1155Metadata: `<b>[페이지 설명]</b>
ERC-1155 NFT 메타데이터를 관리하는 페이지입니다.
파이프(|) 구분자 텍스트 파일을 업로드하여 메타데이터를 등록하고, 기존 목록을 조회/다운로드합니다.

<b>[Column Description]</b>
Token ID :    NFT 토큰 ID
Image :       NFT 이미지 (클릭 시 원본 이미지 열기)
Name :        NFT 이름
Description : NFT 설명
Attributes :  NFT 속성 (trait_type:value 형식)
File Hash :   파일 서버 해시

<b>[File Upload Format]</b>
텍스트 파일 (구분자: 파이프 |), 헤더 없이 데이터만 입력
# tokenId | name | description | image | attributes

1 | CoinGrid Collection 1 | SKYPlay NFT | https://nft.skyplay.io/files/4f3fd03c2d111b8f95d3615c87991257 | {"English Name": "Ali", "Korean Name": "엘리"}
2 | CoinGrid Collection 2 | SKYPlay NFT | https://nft.skyplay.io/files/1bf3fc344ebe5a22cd509fc80afc8c5d | {"English Name": "Bubble", "Korean Name": "버블"}

<b>[주의사항]</b>
* 각 필드는 파이프(|)로 구분하며, 5개 필드가 모두 필요합니다.
* Attributes는 유효한 JSON 문자열이어야 합니다.
* Upload 버튼 클릭 시 확인 후 메타데이터가 서버에 등록됩니다.`,
    erc1155Transaction: `<b>[페이지 설명]</b>
ERC-1155 컨트랙트의 트랜잭션 내역을 조회하는 페이지입니다.
기간별 필터, 타입별 검색(All/Hash/Type), CSV 다운로드 기능을 제공합니다.

<b>[Column Description]</b>
Block Number :     트랜잭션이 포함된 블록 번호
Transaction Hash : 트랜잭션 해시 (Explorer 링크 제공)
Time :             트랜잭션 시간 (로컬 시간 변환)
Type :             트랜잭션 타입 (transfer, mint 등)

<b>[기능]</b>
* 검색 타입 선택 (All, Hash, Type)
* 기간 필터 (fromDate ~ toDate) 로 조회 범위 설정
* CSV 다운로드 (전체 트랜잭션 데이터, 진행률 표시)`,
    erc1155Transfer: `<b>[페이지 설명]</b>
ERC-1155 토큰의 전송(Transfer) 내역을 조회하는 페이지입니다.
기간별 필터, 검색, CSV 다운로드 기능을 제공하며, 시스템 지갑 주소는 녹색으로 표시됩니다.

<b>[Column Description]</b>
Block Number :     트랜잭션이 포함된 블록 번호
Transaction Hash : 트랜잭션 해시 (Explorer 링크 제공)
Time :             전송 시간 (로컬 시간 변환)
From :             발신 주소 (이메일/이름 우선 표시, 시스템 지갑 녹색)
To :               수신 주소 (이메일/이름 우선 표시, 시스템 지갑 녹색)
TokenIds :         전송된 토큰 ID 목록
Quantities :       각 토큰 ID별 전송 수량

<b>[기능]</b>
* 기간 필터 (fromDate ~ toDate) 로 조회 범위 설정
* 검색어 입력으로 필터링
* CSV 다운로드 (전체 데이터 페이징 다운로드, 진행률 표시)
* 컬럼 설정 (ColumnSettings) 으로 표시 컬럼 커스터마이징
* From/To 주소 편집(Edit) 기능 제공`,
    nft1155Add: `<b>[사용 방법]</b>
1. CSV 파일 업로드 또는 수동 입력(Owner, Token ID, Amount)으로 민팅 목록을 등록합니다.
2. Upload 버튼 클릭 시 등록된 목록이 ERC-1155 민팅 요청으로 전송됩니다.

<b>[Column Description]</b>
Sequential : 순번 (자동 생성)
Owner :      NFT 소유자 지갑 주소 (민팅 수신 주소)
Token ID :   민팅할 토큰 ID (ERC-1155는 동일 ID로 여러 개 발행 가능)
Amount :     해당 Token ID의 민팅 수량

<b>[File Upload Format]</b>
CSV 파일 (구분자: 콤마), 헤더 없이 데이터만 입력
# owner, tokenId, amount
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877, 1, 100
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877, 2, 100

<b>[ERC-721 vs ERC-1155]</b>
ERC-721 :  각 토큰이 고유 (1:1), 개별 메타데이터 (이름, 이미지, 속성)
ERC-1155 : 동일 Token ID로 다수 발행 가능 (1:N), 게임 아이템 등에 적합

<b>[주의사항]</b>
* 5개 필드(owner, tokenId, amount, -, attributes)가 필요하며 attributes는 유효한 JSON이어야 합니다.
* Owner는 유효한 EVM 주소여야 합니다.`,
    nft1155Mint: `<b>[페이지 설명]</b>
ERC-1155 NFT 민팅 대기 목록을 관리하는 페이지입니다.
민팅 시작/중지, 개별 활성화/삭제 기능을 제공하며, 3초 간격 자동 갱신됩니다.

<b>[Column Description]</b>
Owner :            민팅 수신 주소 (Explorer 링크 제공)
Token ID :         민팅할 토큰 ID (ERC-1155는 동일 ID로 여러 개 발행 가능)
Amount :           해당 Token ID의 민팅 수량
Transaction Hash : 민팅 트랜잭션 해시 (민팅 완료 시 표시)
Enabled :          민팅 활성화 여부 체크박스 (민팅 완료 시 비활성)
Delete :           항목 삭제 버튼

<b>[기능]</b>
* Start/Stop : 민팅 프로세스 시작/중지
* Select All : 전체 항목 활성화 토글
* CSV 다운로드 (민팅 대기 목록, 진행률 표시)
* 3초 간격 자동 폴링으로 민팅 상태 갱신`,
  },
  erc20: {
    airdrop: `<b>[페이지 설명]</b>
에어드롭 대기 목록을 관리하는 페이지입니다.
전송 대기 상태(status=0)인 에어드롭 항목을 조회, 삭제, 일괄 삭제, CSV 다운로드할 수 있습니다.
Start/Stop 버튼으로 에어드롭 프로세스를 제어합니다.

<b>[Column Description]</b>
Round            : 에어드롭 회차
Sequential       : 순번
Address          : 수신 지갑 주소
Amount           : 전송할 토큰 수량
System Wallet    : 시스템 지갑
Description      : 설명
Transaction Hash : 트랜잭션 해시 (전송 완료 시 표시)
Modified Date    : 수정일
Created Date     : 생성일

<b>[참고]</b>
- 3초 간격 자동 갱신 (프로세스 상태 확인 및 목록 갱신)
- transactionHash가 이미 있는 항목은 삭제/선택 불가`,
    airdropAdd: `<b>[사용 방법]</b>
1. CSV 파일 업로드 또는 수동 입력으로 전송 목록을 등록합니다.
2. Upload 버튼 클릭 시 Round, Description, System Wallet을 설정하는 대화상자가 표시됩니다.
3. Send 버튼으로 등록된 목록을 일괄 전송 요청합니다.

<b>[Column Description]</b>
Sequential : 순번 (자동 생성)
Address :    수신 지갑 주소 (유효한 EVM 주소 필수)
Amount :     전송할 토큰 수량

<b>[File Upload Format]</b>
CSV 파일 (구분자: 콤마), 헤더 없이 데이터만 입력
# Receiving Address, Amount
0x0645Af43088813C44399B79FF45896D68eB23b8F, 100
0x32a4598fCB7272C022557B28dFb8021b6df53F55, 100

<b>[Registration Dialog]</b>
Round :         전송 회차 번호 (마지막 회차 + 1 자동 설정)
Description :   전송 설명 (예: "이벤트 보상", "에어드롭 1차")
System Wallet : 발송에 사용할 시스템 지갑 선택 (활성화된 지갑만 표시)

<b>[주의사항]</b>
* 주소가 유효한 EVM 주소가 아니면 경고 후 무시됩니다.
* Amount가 숫자가 아닌 경우 경고 후 무시됩니다.
* System Wallet을 반드시 선택해야 전송이 가능합니다.`,
    airdropHistory: `<b>[페이지 설명]</b>
에어드롭 완료 이력을 조회하는 페이지입니다.
전송 완료 상태(status=1)인 에어드롭 항목을 회차별, 기간별로 검색할 수 있습니다.
상세 CSV 및 요약 리포트 CSV 다운로드를 지원합니다.

<b>[Column Description]</b>
Round            : 에어드롭 회차
Sequential       : 순번
Address          : 수신 지갑 주소 (이름 등록 시 이름 표시)
Amount           : 전송된 토큰 수량 (3,000 초과 녹색 / 5,000 초과 노란색 / 10,000 초과 빨간색)
Description      : 설명 (인라인 편집 가능)
Memo             : 메모 (인라인 편집 가능)
Transaction Hash : 트랜잭션 해시
Modified Date    : 수정일

<b>[참고]</b>
- Round 필터로 특정 회차만 조회 가능
- Download Detail: 건별 상세 CSV
- Download Report: 회차별 요약 리포트 CSV`,
    dashboard: `<b>[페이지 설명]</b>
ERC20 토큰의 실시간 모니터링 대시보드 페이지입니다.
SSE(Server-Sent Events) 및 Polling을 통해 실시간 데이터를 갱신합니다.

<b>[실시간 카드]</b>
LBank Price       : LBank 거래소 현재 토큰 가격
24h Change         : 24시간 가격 변동률 (%)
Bot Status         : MM 봇 활성/비활성 상태
Trading Volume     : 거래량

<b>[전송 통계 카드]</b>
Withdraw 24h       : 최근 24시간 출금 금액
Transfers 1h       : 최근 1시간 전송 건수
Transfers 1h Amt   : 최근 1시간 전송 금액
Transfers 24h      : 최근 24시간 전송 건수
Transfers 24h Amt  : 최근 24시간 전송 금액

<b>[차트]</b>
TYPE Distribution     : 지갑 타입별 토큰 분배 도넛 차트 (Default, Company, Exchange 등)
EXCHANGE Distribution : 거래소별 토큰 분배 도넛 차트
Transfer Bar Chart    : 기간별 전송 금액/건수 막대 차트 (24H / 7D / 30D / Monthly / Custom)
LBank Trading Volume  : LBank 거래량 라인 차트 (7D / 30D / 90D)
Daily PnL             : 일일 손익 차트 (7D / 30D / 90D)
Holder Distribution   : 보유량 구간별 홀더 분포 차트

<b>[참고]</b>
- 자동 갱신(Auto Refresh) 30초 주기 폴링
- SSE 연결 상태 표시 (Live / Offline)`,
    erc20DepositHistory: `<b>[페이지 설명]</b>
ERC20 토큰 입금(Deposit) 이력을 조회하는 페이지입니다.
블록체인에서 감지된 입금 트랜잭션을 기간별로 검색하고 CSV 다운로드할 수 있습니다.

<b>[Column Description]</b>
Block Number : 블록 번호
Time         : 트랜잭션 발생 시간
From         : 송신 지갑 주소 (시스템 지갑인 경우 녹색 표시)
To           : 수신 지갑 주소
Value        : 입금 토큰 수량 (3,000 초과 녹색 / 5,000 초과 노란색 / 10,000 초과 빨간색)

<b>[참고]</b>
- 기간 필터(From/To Date)로 조회 범위 설정 가능
- 시스템 지갑 주소는 녹색으로 강조 표시`,
    erc20Holder: `<b>[Column Description]</b>
Address : 토큰 보유자 지갑 주소
Type :    홀더 분류 (편집 가능, 아래 Type 코드 참조)
Owner :   홀더 별칭/이름 (편집 가능)
Amount :  토큰 보유량

<b>[Search Options]</b>
All :     전체 검색
Name :    별칭(Owner)으로 검색
Type :    Type 코드로 검색 (숫자 입력)
More :    입력값 이상 보유자 필터
Less :    입력값 이하 보유자 필터

<b>[File Upload Format]</b>
CSV 파일로 홀더 정보 일괄 업데이트 (구분자: 콤마)
# Holder Address, Alias, Type
0x0645Af43088813C44399B79FF45896D68eB23b8F, User_1, 11
0x32a4598fCB7272C022557B28dFb8021b6df53F55, User_2, 11

<b>[Type Code]</b>
 0  Default       — 미분류
 1  Company       — 회사 보유
 2  Exchange      — 거래소
 3  Marketing     — 마케팅 물량
 4  Sale          — 판매 물량
 5  Staking       — 스테이킹
 6  Team          — 팀 물량
 7  CM liquidity  — 커뮤니티 유동성
 8  Advisor       — 어드바이저
 9  Unlock        — 언락 물량
10  Portal        — 포털 시스템
11  System        — 시스템 지갑`,
    erc20LockupSchedules: `<b>[페이지 설명]</b>
ERC20 토큰 락업(Lockup) 스케줄 조회 페이지입니다.
스마트 컨트랙트에 설정된 락업 정보를 확인할 수 있습니다.

<b>[Column Description]</b>
account           : 락업 대상 지갑 주소
amount            : 락업 토큰 수량
startTime         : 락업 시작 시간
releasePercentage : 해제 비율 (%)
releasedValue     : 해제된 토큰 수량

<b>[참고]</b>
- CSV 다운로드 지원`,
    erc20Transaction: `<b>[페이지 설명]</b>
ERC20 컨트랙트 트랜잭션(Transaction) 이력 조회 페이지입니다.
블록체인에서 발생한 컨트랙트 트랜잭션을 타입별, 해시별로 검색할 수 있습니다.

<b>[Column Description]</b>
Block Number     : 블록 번호
Transaction Hash : 트랜잭션 해시
Time             : 트랜잭션 발생 시간
Type             : 트랜잭션 타입 (transfer, approve 등)

<b>[검색 옵션]</b>
All  : 전체 검색
Hash : 트랜잭션 해시로 검색
Type : 트랜잭션 타입으로 검색

<b>[참고]</b>
- 기간 필터(From/To Date)로 조회 범위 설정 가능
- CSV 다운로드 지원`,
    erc20TransactionStatus: `<b>[페이지 설명]</b>
트랜잭션 상태 모니터링 페이지입니다.
블록체인에 전송된 트랜잭션의 처리 상태를 확인하고, 실패 건을 재시도하거나 삭제할 수 있습니다.

<b>[Column Description]</b>
Address          : 수신 지갑 주소
Transaction Hash : 트랜잭션 해시
Status           : 트랜잭션 상태 (PENDING: 대기 / FAILED: 실패 / 기타)
Modified Date    : 수정일
Created Date     : 생성일
Retry            : 실패 트랜잭션 재시도 버튼
Delete           : 트랜잭션 기록 삭제 버튼

<b>[참고]</b>
- FAILED 상태 빨간색 칩, PENDING 상태 주황색 칩으로 표시
- CSV 다운로드 지원`,
    erc20Transfer: `<b>[페이지 설명]</b>
ERC20 토큰 Transfer 이력을 조회하는 페이지입니다.
블록체인에서 발생한 토큰 전송 트랜잭션을 다양한 검색 조건으로 조회할 수 있습니다.

<b>[Column Description]</b>
Block Number     : 블록 번호
Transaction Hash : 트랜잭션 해시
Time             : 트랜잭션 발생 시간
From             : 송신 지갑 주소 (시스템 지갑 녹색 표시, 이름/이메일 등록 시 표시)
To               : 수신 지갑 주소 (시스템 지갑 녹색 표시, 이름/이메일 등록 시 표시)
Value            : 전송 토큰 수량

<b>[검색 옵션]</b>
All  : 전체 검색
Hash : 트랜잭션 해시로 검색
Name : 이름으로 검색
Type : 주소 타입으로 검색
More : 입력값 이상 금액 검색
Less : 입력값 이하 금액 검색
From : 송신 주소로 검색
To   : 수신 주소로 검색

<b>[참고]</b>
- 기간 필터(From/To Date)로 조회 범위 설정 가능
- 주소 이름/타입 편집 모달 제공
- CSV 다운로드 지원`,
    erc20Withdraw: `<b>[페이지 설명]</b>
출금 요청 대기 목록을 관리하는 페이지입니다.
사용자가 요청한 출금 건을 승인/거절하고, 출금 프로세스를 Start/Stop 할 수 있습니다.
일괄 승인(Batch Approve), 일괄 거절(Batch Reject) 기능을 지원합니다.

<b>[Column Description]</b>
Issuer           : 발행자 (요청 출처)
Address          : 수신 지갑 주소 (이름 등록 시 이름 표시, 중복 주소 노란색 표시)
Amount           : 출금 요청 금액 (3,000 초과 녹색 / 5,000 초과 노란색 / 10,000 초과 빨간색)
Transaction Hash : 트랜잭션 해시 (처리 완료 시 표시)
Request Date     : 출금 요청 일시
System Wallet    : 시스템 지갑 선택
Enabled          : 출금 활성화 체크박스

<b>[참고]</b>
- Request Date 기준: 05:00 UTC (14:00 KST)
- 3초 간격 자동 갱신 (프로세스 상태 확인 및 목록 갱신)
- 블랙리스트 등록 버튼으로 주소 차단 가능
- Select All 버튼으로 전체 활성화/비활성화 토글`,
    erc20WithdrawBlacklist: `<b>[페이지 설명]</b>
출금 블랙리스트 관리 페이지입니다.
블랙리스트에 등록된 주소 목록을 조회하고, 사유 편집 및 블랙리스트 해제를 할 수 있습니다.

<b>[Column Description]</b>
Issuer                       : 발행자
Address                      : 블랙리스트 등록된 지갑 주소 (빨간색 표시)
Withdrawal Suspension Reason : 출금 정지 사유 (인라인 편집 가능)
Registered Date              : 블랙리스트 등록일

<b>[참고]</b>
- 주소 호버 시 블랙리스트 해제(Restore) 버튼 제공
- CSV 다운로드 지원`,
    erc20WithdrawHistory: `<b>[페이지 설명]</b>
출금 완료 이력을 조회하는 페이지입니다.
처리 완료 상태(status=1)인 출금 건을 기간별로 검색하고 CSV 다운로드할 수 있습니다.

<b>[Column Description]</b>
Issuer           : 발행자 (요청 출처)
Address          : 수신 지갑 주소 (블랙리스트 빨간색, 중복 주소 노란색 표시)
Amount           : 출금 금액 (3,000 초과 녹색 / 5,000 초과 노란색 / 10,000 초과 빨간색)
Transaction Hash : 트랜잭션 해시
Request Date     : 출금 요청 일시
Withdrawal Date  : 출금 처리 일시

<b>[참고]</b>
- 기간 필터(From/To Date)로 조회 범위 설정 가능
- 블랙리스트 등록 버튼으로 주소 차단 가능
- 주소 상세 조회(Expand) 시 동일 주소 사용자 목록 표시`,
    erc20WithdrawHold: `<b>[페이지 설명]</b>
출금 보류(Hold) 목록을 조회하는 페이지입니다.
보류 상태(status=4)인 출금 건을 관리합니다.

<b>[Column Description]</b>
Issuer        : 발행자 (요청 출처)
Address       : 수신 지갑 주소 (블랙리스트 빨간색, 중복 주소 노란색 표시)
Amount        : 보류된 출금 금액 (3,000 초과 녹색 / 5,000 초과 노란색 / 10,000 초과 빨간색)
Request Date  : 출금 요청 일시

<b>[참고]</b>
- 블랙리스트 등록 버튼으로 주소 차단 가능
- CSV 다운로드 지원`,
    erc20WithdrawRefusal: `<b>[페이지 설명]</b>
출금 거절 이력을 조회하는 페이지입니다.
관리자가 거절한 출금 요청(status=3) 목록을 확인할 수 있습니다.

<b>[Column Description]</b>
Issuer           : 발행자 (요청 출처)
Address          : 수신 지갑 주소 (블랙리스트 빨간색, 중복 주소 노란색 표시)
Amount           : 출금 요청 금액 (3,000 초과 녹색 / 5,000 초과 노란색 / 10,000 초과 빨간색)
Rejection Reason : 거절 사유
Request Date     : 출금 요청 일시

<b>[참고]</b>
- CSV 다운로드 지원
- 주소 상세 조회(Expand) 시 동일 주소 사용자 목록 표시`,
    holderAnalysis: `<b>[페이지 설명]</b>
ERC20 토큰 홀더 분석 페이지입니다.
토큰 보유자 현황을 다양한 차트와 테이블로 분석할 수 있습니다.

<b>[요약 카드]</b>
Total Holders       : 전체 홀더 수
Total Supply        : 전체 토큰 공급량
Top 10 Concentration : 상위 10개 주소의 보유 비율 (%)
Average Balance     : 홀더 평균 보유량

<b>[차트]</b>
Top Holder Concentration : 상위 홀더(Top 10/50/100) 집중도 도넛 차트
Balance Distribution     : 보유량 구간별 홀더 분포 (0-100, 100-1K, 1K-10K 등)
Holder Type Breakdown    : 홀더 타입별 분포 도넛 차트
Type Summary             : 타입별 보유량 및 비율 요약 테이블

<b>[Top Holders 테이블]</b>
#          : 순위
Address    : 지갑 주소
Name       : 등록된 이름
Balance    : 보유 토큰 수량
Share      : 전체 대비 보유 비율 (%)
Cumulative : 누적 보유 비율 (%)

<b>[참고]</b>
- CSV / Excel / PDF 내보내기 지원`,
    rules: `<b>[페이지 설명]</b>
출금 규칙(Rules) 관리 페이지입니다.
출금 시 적용할 규칙을 생성, 수정, 삭제할 수 있습니다.

<b>[규칙 타입]</b>
갯수 (Type 0)    : 1회 출금 수량 제한 설정
횟수 (Type 1)    : 일정 기간(초) 내 출금 횟수 제한 설정
지갑주소 (Type 2) : 특정 지갑 주소 기반 규칙 설정

<b>[참고]</b>
- Add Rules 버튼으로 새 규칙 추가
- 수정/삭제 버튼으로 기존 규칙 관리`,
    skyPlayWallet: `<b>[페이지 설명]</b>
사용자 지갑 관리 페이지입니다.
계정별 지갑 주소, 토큰 잔액을 조회하고, 신규 지갑을 생성할 수 있습니다.

<b>[Column Description]</b>
Account ID    : 사용자 계정 ID (블랙리스트 등록 시 빨간색 표시)
Address       : 지갑 주소
Nickname      : 닉네임
MATIC         : MATIC 잔액 (실시간 RPC 조회)
METAQ         : METAQ 토큰 잔액
Modified Date : 수정일
Created Date  : 생성일

<b>[참고]</b>
- Create Wallet 버튼으로 AccountId 기반 신규 지갑 생성
- 블랙리스트 등록 가능
- CSV 다운로드 지원`,
    crossNetwork: `<b>[페이지 설명]</b>
크로스 네트워크 분석(Cross-Network Analysis) 페이지입니다.
ERC20, ERC721, ERC1155 토큰 타입 전체에 대한 통합 활동 뷰를 제공합니다.
네트워크 메트릭을 사이드 바이 사이드로 비교하고 토큰 표준별 활동 타임라인을 추적합니다.

<b>[필터]</b>
Token Type Toggle : 전체 / ERC20 / ERC721 / ERC1155 필터
From / To :         기간 설정
Address Search :    특정 지갑 주소의 전체 활동 검색

<b>[Summary Cards]</b>
Total Transactions : 전체 네트워크 총 트랜잭션 건수
Unique Addresses :   고유 지갑 주소 수
Active Networks :    활동이 있는 네트워크 수
ERC20 / ERC721 / ERC1155 : 토큰 타입별 트랜잭션 건수

<b>[차트]</b>
Network Comparison :  네트워크별 전송, 민팅, 소각을 보여주는 스택형 막대 차트
Activity Timeline :   ERC20, ERC721, ERC1155 일별 활동의 별도 시리즈가 있는 라인 차트

<b>[테이블]</b>
Network Breakdown :   네트워크별 상세 메트릭 (타입, TX 건수, 고유 주소, 전송, 민팅, 소각)
Combined Activity :   타임스탬프 기준 정렬된 통합 활동 피드 (시간, 타입, 액션, From, To, 금액/TokenId, 네트워크, TX Hash)

<b>[주소 검색]</b>
이더리움 주소를 입력하면 전체 토큰 타입에 걸친 크로스 네트워크 활동을 조회할 수 있습니다.`,
    holderTracking: `<b>[페이지 설명]</b>
ERC20 토큰 홀더 변동 추적 페이지입니다.
정기적인 스냅샷을 통해 홀더 수 변화, 분포 변동, 상위 홀더 변동을 시계열 차트로 추적합니다.

<b>[필터]</b>
From / To :   스냅샷 데이터 조회 기간
Group By :    일별 / 주별 / 월별 집계

<b>[Summary Cards]</b>
총 홀더 수 :           현재 총 토큰 홀더 수
신규 홀더 (24시간) :    최근 24시간 내 신규 홀더 수
이탈 홀더 (24시간) :    최근 24시간 내 이탈한 홀더 수
평균 잔액 :            홀더당 평균 토큰 잔액

<b>[차트]</b>
홀더 수 변동 추이 :      선택 기간의 총 홀더 수 변화를 보여주는 라인 차트
분포 변동 이력 :         잔액 구간별(0-100, 100-1K, 1K-10K, 10K-100K, 100K+) 홀더 분포를 보여주는 스택형 영역 차트

<b>[상위 20 홀더 테이블]</b>
순위 :       잔액 기준 홀더 순위
주소 :       지갑 주소
이름 :       등록된 이름/별명
잔액 :       현재 토큰 잔액
비율 % :     총 공급량 대비 비율
24시간 변동 : 최근 24시간 잔액 변동
7일 변동 :    최근 7일 잔액 변동

<b>[기능]</b>
- 스냅샷 생성 : 수동으로 홀더 스냅샷을 생성 (현재 상태를 DB에 저장)
- CSV / Excel / PDF 내보내기 지원
- 다크/라이트 테마 지원`,
  },
  erc721: {
    erc721Holder: `<b>[페이지 설명]</b>
ERC-721 토큰 홀더(보유자) 목록을 조회하는 페이지입니다.
각 주소별 보유 수량을 확인할 수 있으며, 정렬/검색/CSV 다운로드 기능을 제공합니다.

<b>[Column Description]</b>
Address :  토큰 보유자 지갑 주소 (Explorer 링크 제공)
Quantity : 해당 주소가 보유한 ERC-721 토큰 수량

<b>[기능]</b>
* 검색어로 주소 필터링
* 컬럼 정렬 (Address, Quantity)
* CSV 다운로드 (전체 홀더 목록, 진행률 표시)
* Total 표시: 전체 토큰 보유 수량 합계`,
    erc721Inventory: `<b>[페이지 설명]</b>
ERC-721 NFT 인벤토리(소유 현황) 페이지입니다.
각 토큰의 메타데이터(이미지, 이름, 설명, 속성)와 소유자 정보를 조회합니다.

<b>[Column Description]</b>
Token ID :    NFT 토큰 고유 ID
Image :       NFT 이미지 (클릭 시 Explorer 또는 IPFS 링크로 이동)
Owner :       현재 소유자 지갑 주소 (Explorer 링크 제공)
Name :        NFT 이름
Description : NFT 설명
Attributes :  NFT 속성 (trait_type:value 형식)

<b>[기능]</b>
* 검색어로 인벤토리 필터링
* CSV 다운로드 (전체 인벤토리, 진행률 표시)
* 이미지 클릭 시 Etherscan NFT 페이지 또는 IPFS 이미지 열기`,
    erc721Transaction: `<b>[페이지 설명]</b>
ERC-721 컨트랙트의 트랜잭션 내역을 조회하는 페이지입니다.
기간별 필터, 타입별 검색(All/Hash/Type), CSV 다운로드 기능을 제공합니다.

<b>[Column Description]</b>
Block Number :     트랜잭션이 포함된 블록 번호
Transaction Hash : 트랜잭션 해시 (Explorer 링크 제공)
Time :             트랜잭션 시간 (로컬 시간 변환)
Type :             트랜잭션 타입 (transfer, mint 등)

<b>[기능]</b>
* 검색 타입 선택 (All, Hash, Type)
* 기간 필터 (fromDate ~ toDate) 로 조회 범위 설정
* CSV 다운로드 (전체 트랜잭션 데이터, 진행률 표시)`,
    erc721Transfer: `<b>[페이지 설명]</b>
ERC-721 토큰의 전송(Transfer) 내역을 조회하는 페이지입니다.
기간별 필터, 검색, CSV 다운로드 기능을 제공하며, 시스템 지갑 주소는 녹색으로 표시됩니다.

<b>[Column Description]</b>
Block Number :     트랜잭션이 포함된 블록 번호
Transaction Hash : 트랜잭션 해시 (Explorer 링크 제공)
Time :             전송 시간 (로컬 시간 변환)
From :             발신 주소 (이메일/이름 우선 표시, 시스템 지갑 녹색)
To :               수신 주소 (이메일/이름 우선 표시, 시스템 지갑 녹색)
Token ID :         전송된 NFT 토큰 ID

<b>[기능]</b>
* 기간 필터 (fromDate ~ toDate) 로 조회 범위 설정
* 검색어 입력으로 필터링
* CSV 다운로드 (전체 데이터 페이징 다운로드, 진행률 표시)
* 컬럼 설정 (ColumnSettings) 으로 표시 컬럼 커스터마이징`,
    nft721Add: `<b>[사용 방법]</b>
1. 파이프(|) 구분자 텍스트 파일을 업로드하여 NFT 민팅 목록을 등록합니다.
2. Upload 버튼 클릭 시 등록된 목록이 민팅 요청으로 전송됩니다.

<b>[Column Description]</b>
Sequential :  순번 (자동 생성)
Owner :       NFT 소유자 지갑 주소 (민팅 수신 주소)
Name :        NFT 이름 (컬렉션명)
Description : NFT 설명
Image :       NFT 이미지 URL (TUS 파일 업로드 서버 URL 등)
Attributes :  NFT 메타데이터 속성 (JSON 형식 필수)

<b>[File Upload Format]</b>
텍스트 파일 (구분자: 파이프 |), 헤더 없이 데이터만 입력
# owner | name | description | image | attributes

0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877 | Collection 1 | METAPLANET NFT | https://appsdev.metaplanet.tech/files/e4606e4f42f73b832ba8b530f8a4e8d1 | {"English Name": "MARRON"}
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877 | Collection 2 | METAPLANET NFT | https://appsdev.metaplanet.tech/files/a80bb676e130f46184d7b4554eeaf364 | {"English Name": "PENNY"}

<b>[주의사항]</b>
* 각 필드는 파이프(|)로 구분하며, 5개 필드가 모두 필요합니다.
* Attributes는 반드시 유효한 JSON 문자열이어야 합니다. (파싱 실패 시 해당 줄 무시)
* Image URL은 테이블에서 미리보기 이미지로 표시됩니다.`,
    nft721Mint: `<b>[페이지 설명]</b>
ERC-721 NFT 민팅 대기 목록을 관리하는 페이지입니다.
민팅 시작/중지, 개별/일괄 활성화, 삭제 기능을 제공하며, 3초 간격 자동 갱신됩니다.

<b>[Column Description]</b>
Image :            NFT 이미지 미리보기
Name :             NFT 이름
Description :      NFT 설명
File Hash :        파일 서버 해시 (파일 링크 제공)
Owner :            민팅 수신 주소 (Explorer 링크 제공)
Attributes :       NFT 속성 (trait_type:value 형식)
Transaction Hash : 민팅 트랜잭션 해시 (민팅 완료 시 표시)
Enabled :          민팅 활성화 여부 체크박스 (민팅 완료 시 비활성)
Delete :           항목 삭제 버튼

<b>[기능]</b>
* Start/Stop : 민팅 프로세스 시작/중지
* Select All : 전체 항목 활성화 토글
* Batch Enable : 선택된 항목 일괄 활성화
* Batch Delete : 선택된 항목 일괄 삭제
* CSV 다운로드 (민팅 대기 목록, 진행률 표시)
* 3초 간격 자동 폴링으로 민팅 상태 갱신`,
    nft721MintHistory: `<b>[페이지 설명]</b>
ERC-721 NFT 민팅 완료 이력을 조회하는 페이지입니다.
민팅이 완료된 NFT 항목의 상세 정보와 트랜잭션 해시를 확인할 수 있습니다.

<b>[Column Description]</b>
Image :            NFT 이미지 미리보기
Name :             NFT 이름
Description :      NFT 설명
Owner :            NFT 소유자 지갑 주소 (Explorer 링크 제공)
Attributes :       NFT 속성 (trait_type:value 형식)
Transaction Hash : 민팅 트랜잭션 해시 (Explorer 링크 제공)
Updated Date :     마지막 수정 일시
Created Date :     최초 등록 일시

<b>[기능]</b>
* 검색어로 민팅 이력 필터링
* CSV 다운로드 (전체 민팅 이력, 진행률 표시)
* status=1 (민팅 완료) 항목만 조회`,
  },
  mpc: {
    createWallet: `<b>[페이지 설명]</b>
MPC(다자간 연산) 지갑을 생성하는 페이지입니다.
지갑명, 소유자 목록, 최소 승인자 수(threshold)를 설정하여 생성합니다.

<b>[입력 항목]</b>
지갑명 :            MPC 지갑 이름
지갑 생성자 :       기본 승인 유저 (로그인된 사용자)
승인유저 :          추가 소유자 선택 (등록된 MPC 사용자 목록에서 선택)
최소 승인자 수 :    트랜잭션 승인에 필요한 최소 인원 (threshold)`,
    issueTransaction: `<b>[페이지 설명]</b>
MPC 지갑에서 토큰 전송을 요청하는 페이지입니다.
MPC 지갑 목록에서 잔액을 확인하고, 전송 요청 다이얼로그에서 받는 주소와 수량을 입력합니다.

<b>[Column Description]</b>
지갑주소(MPC) :     MPC 지갑 주소
서명인/소유자 :     threshold / partySize (승인자 수 / 전체 소유자 수)
SKP (전송대기) :    SKP 잔액 (deposit 포함)
matic :             MATIC 잔액
전송 :              전송 요청 버튼

<b>[전송 요청 다이얼로그]</b>
지갑주소(MPC) :     보내는 MPC 지갑 주소 (읽기 전용)
받는 주소 :         등록된 MPC 사용자 중 선택
수량 :              전송할 SKP 수량`,
    registerAddress: `<b>[페이지 설명]</b>
MPC 사용자 주소를 등록/관리하는 페이지입니다.
MPC 지갑 생성 시 소유자로 지정할 수 있는 사용자 주소를 CRUD합니다.

<b>[Column Description]</b>
사용자명 :      MPC 사용자 이름
지갑주소 :      사용자 지갑 주소

<b>[기능]</b>
추가(+) :       사용자명과 지갑주소를 입력하여 등록
삭제(-) :       선택된 사용자를 삭제`,
    transferHistory: `<b>[페이지 설명]</b>
MPC 지갑 전송 이력을 조회하는 페이지입니다.
승인 상태에 따라 SKP 전송 또는 재전송 버튼이 표시됩니다.

<b>[Column Description]</b>
지갑주소(MPC) :     보내는 MPC 지갑 주소
받는주소 :          수신자 주소
Amount :            전송 수량
승인상태 :          트랜잭션 진행 상태
전송 :              SKP 전송/재전송 버튼

<b>[승인상태 코드]</b>
0 : 승인 요청
1 : 승인 완료 (SKP 전송 가능)
2 : MPC 요청
3 : MPC 완료 / 전송 요청 (트랜잭션 해시 확인 가능)
4 : 전송 확인
5 : 전송 에러
6 : 서명 에러 (SKP 재전송 가능)`,
    waitingApproval: `<b>[페이지 설명]</b>
MPC 지갑 전송 승인 대기 목록을 조회하는 페이지입니다.
승인 대기 중인 트랜잭션에 서명(승인)할 수 있습니다.

<b>[Column Description]</b>
지갑주소(MPC) :     보내는 MPC 지갑 주소
받는주소 :          수신자 주소
Amount :            전송 수량
서명수 :            현재 서명 수 / 필요 서명 수 (서명자 목록 확인 가능)
승인 :              승인 버튼`,
  },
  platform: {
    gameNotice: `<b>[페이지 설명]</b>
게임 공지사항을 관리하는 페이지입니다.
SmartEditor로 본문을 작성하며, 추가/수정/삭제가 가능합니다.
notice.skyplay.io 사이트에 게시됩니다.

<b>[Column Description]</b>
Seq :           순번
Gamename :      게임명 (clashrow, coingrid)
Category :      카테고리 (Public, Update, Maintenance, Event)
Subject :       제목
Language :      언어 (ko/en)
State :         상태 (0: New, 1: Old)
Modified Date : 수정 일시
Created Date :  생성 일시
link :          콘텐츠 보기
edit :          수정 버튼
delete :        삭제 버튼`,
    pressRelease: `<b>[페이지 설명]</b>
보도자료(Press Release)를 관리하는 페이지입니다.
SmartEditor로 본문을 작성하며, 추가/수정/삭제가 가능합니다.
skyplayinc.com 사이트에 게시됩니다.

<b>[Column Description]</b>
Seq :           순번
Subject :       제목
URL :           외부 링크 URL
Language :      언어 (ko/en)
Created Date :  생성 일시
link :          콘텐츠 보기
edit :          수정 버튼
delete :        삭제 버튼`,
    tusUploadList: `<b>[페이지 설명]</b>
TUS 프로토콜 파일 업로드 목록을 조회하는 페이지입니다.
드래그앤드롭으로 파일을 업로드하며, 3초 간격으로 목록이 자동 갱신됩니다.
CSV 다운로드 기능을 제공합니다.

<b>[Column Description]</b>
Seq :           순번
Image :         이미지 미리보기 (이미지 파일인 경우)
MIME Type :     파일 타입 (image/png 등)
ID :            TUS 파일 ID
Name :          파일명
Size :          파일 크기
Created Date :  업로드 일시
link :          파일 링크 (새 탭)`,
  },
  portal: {
    board: `<b>[페이지 설명]</b>
포털 게시판(Board) 관리 페이지입니다.
게시글 목록 조회, 추가, 수정, 삭제 및 SmartEditor를 이용한 컨텐츠 편집이 가능합니다.

<b>[Column Description]</b>
Rowid :         게시글 고유 번호
Type :          게시판 유형 (arena, notice, news, partner, event, info)
Title :         게시글 제목
Language :      언어 코드 (eng, kor, vnm, chn)
Registed Date : 등록 일시

<b>[기능]</b>
* 게시글 추가(Add) : SmartEditor로 HTML 컨텐츠 작성
* 게시글 수정(Edit) : 기존 컨텐츠를 불러와 수정
* 게시글 삭제(Delete) : 확인 후 삭제
* View content : press.metaplanet-nft.com 에서 미리보기`,
    mintit: `<b>[페이지 설명]</b>
Mintit 신청 목록을 조회하고 확인(confirm) 처리하는 페이지입니다.
CSV 다운로드 및 지갑 주소 검색이 가능합니다.

<b>[Column Description]</b>
seq :             순번
name :            신청자 이름
phone :           전화번호
wallet :          지갑 주소 (복사, 탐색기 링크, 필터 기능)
transactionHash : 트랜잭션 해시
dateUpdated :     수정 일시
dateCreated :     등록 일시
confirm :         확인 여부 (체크박스, transactionHash가 있으면 비활성화)`,
  },
  portalLog: {
    ltbDeposit: `<b>[페이지 설명]</b>
포털 입금(Deposit) 로그를 조회하는 페이지입니다.
총 건수(Total)와 총 METAQ 수량을 상단에 표시합니다.
주소 복사, 블록체인 탐색기 링크, 필터 기능을 제공합니다.

<b>[Column Description]</b>
seq :       순번
from :      보낸 주소
to :        받는 주소
txnhash :   트랜잭션 해시
value :     입금 수량
redDate :   등록 일시`,
    ltbMetaq: `<b>[페이지 설명]</b>
포털 METAQ 잔액 변동 로그를 조회하는 페이지입니다.
METAQ의 증감 내역과 사유를 확인합니다.

<b>[Column Description]</b>
seq :       순번
wallet :    지갑 주소
bef :       변동 전 잔액
val :       변동 수량
aft :       변동 후 잔액
reason :    변동 사유
regDate :   등록 일시`,
    ltbNftStaking: `<b>[페이지 설명]</b>
포털 NFT 스테이킹 로그를 조회하는 페이지입니다.
NFT 토큰별 스테이킹 시작/종료/수령 일시를 확인합니다.

<b>[Column Description]</b>
seq :           순번
tokenId :       NFT 토큰 ID
beginDate :     스테이킹 시작 일시
endDate :       스테이킹 종료 일시
receivDate :    보상 수령 일시`,
    ltbSwap: `<b>[페이지 설명]</b>
포털 스왑(Swap) 로그를 조회하는 페이지입니다.
AQUA에서 METAQ로의 스왑 내역을 확인하며, 총 건수와 총 AQUA 수량을 표시합니다.
METAQ 수량은 ratio * value로 자동 계산됩니다.

<b>[Column Description]</b>
seq :       순번
wallet :    지갑 주소
contentNo : 컨텐츠 번호
ratio :     교환 비율
AQUA :      AQUA 수량 (value)
METAQ :     METAQ 수량 (ratio x value, 계산값)
regDate :   등록 일시`,
    ltbTokens: `<b>[페이지 설명]</b>
포털 토큰(AQUA) 변동 로그를 조회하는 페이지입니다.
AQUA 토큰의 증감 내역과 사유를 확인하며, CSV 다운로드 기능을 제공합니다.

<b>[Column Description]</b>
seq :           순번
wallet :        지갑 주소
contentNo :     컨텐츠 번호
type :          변동 타입
no :            번호
bef :           변동 전 잔액
val :           변동 수량
aft :           변동 후 잔액
reason :        변동 사유
regDate :       등록 일시`,
    ltbTransferMetaq: `<b>[페이지 설명]</b>
포털 METAQ 전송(Transfer) 로그를 조회하는 페이지입니다.
사용자 간 METAQ 전송 내역을 확인합니다.
주소 복사, 블록체인 탐색기 링크, 필터 기능을 제공합니다.

<b>[Column Description]</b>
seq :       순번
from :      보낸 주소
to :        받는 주소
val :       전송 수량
regDate :   등록 일시`,
    ltbTransferNft: `<b>[페이지 설명]</b>
포털 NFT 전송(Transfer) 로그를 조회하는 페이지입니다.
NFT 토큰의 소유권 이전 내역을 확인합니다.
주소 복사, 블록체인 탐색기 링크, 필터 기능을 제공합니다.

<b>[Column Description]</b>
seq :       순번
from :      보낸 주소
to :        받는 주소
tokenId :   NFT 토큰 ID
regDate :   등록 일시`,
    ltbWithdraw: `<b>[페이지 설명]</b>
포털 출금(Withdraw) 로그를 조회하는 페이지입니다.
총 건수(Total)와 총 METAQ 출금 수량을 상단에 표시합니다.
트랜잭션 해시로 블록체인 탐색기에서 확인 가능합니다.

<b>[Column Description]</b>
seq :           순번
wallet :        지갑 주소
value :         출금 수량
regDate :       요청 일시
txnhash :       트랜잭션 해시
confirmDate :   확인 일시`,
  },
  portalToken: {
    balanceHistoryProbit: `<b>[페이지 설명]</b>
Probit 거래소 잔고 이력(Balance History) 페이지입니다.
LP1/LP2 계정의 USDT, METAQ 잔고 변동을 시간대별로 추적합니다.
현재 잔고와 과거 잔고의 차이(Delta)를 계산하여 상단에 표시합니다.
1초 간격으로 자동 갱신됩니다.

<b>[Column Description]</b>
time :           기록 시간 (ISO 형식)
lp1 usdt :       LP1 계정 USDT 잔고
lp2 usdt :       LP2 계정 USDT 잔고
usdt :           USDT 합계 (LP1 + LP2)
lp1 metaq :      LP1 계정 METAQ 잔고
lp2 metaq :      LP2 계정 METAQ 잔고
metaq :          METAQ 합계 (LP1 + LP2)
sum(usdt) :      METAQ x 현재가 + USDT (총 자산 환산)
거래평균가 :      USDT 변동 / METAQ 변동 (상단 Delta 테이블)

<b>[참고]</b>
* 상단 테이블 : 현재 실시간 잔고 및 기간별 변동(Delta) 표시
* 하단 테이블 : 과거 잔고 이력 (서버 페이지네이션)
* CSV 다운로드 가능`,
    coinsale: `<b>[페이지 설명]</b>
Coin Sale(코인 판매) 참여자를 등록, 수정, 삭제하고 목록을 조회하는 페이지입니다.
총 판매 금액(Sum) 합계를 표시하며 CSV 다운로드가 가능합니다.

<b>[Column Description]</b>
seq :         순번
nickname :    참여자 닉네임
description : 설명
deposit :     입금액
depositDate : 입금 일자
salePrice :   판매 가격
metaq :       배분 METAQ 수량
completed :   완료 여부
lockup :      락업 여부

<b>[주의사항]</b>
* 지갑 주소(Wallet)는 유효한 이더리움 주소여야 등록 가능합니다.
* Sum 표시는 서버에서 계산된 totalAmount 값입니다.`,
    gasAnalysis: `<b>[페이지 설명]</b>
가스비 분석(Gas Analysis) 페이지입니다.
네트워크별, 트랜잭션 타입별 가스 소비량을 분석하고 차트로 시각화합니다.
CSV, Excel, PDF 내보내기를 지원합니다.

<b>[필터]</b>
Network :         네트워크 선택 (All Networks 포함)
From / To :       기간 설정
Gas Price (Gwei) : 가스 가격 설정 (기본값: 20)

<b>[Summary Cards]</b>
Total Transactions : 총 트랜잭션 건수
Est. Total Gas :     예상 총 가스 소비량
Est. Total Cost :    예상 총 비용 (ETH)
Avg Gas / TX :       트랜잭션당 평균 가스

<b>[차트]</b>
Daily Gas Cost Trend :  일별 TX 건수(막대) + 비용 추이(선)
TX Type Distribution :  트랜잭션 타입별 비율 (도넛 차트)

<b>[테이블]</b>
Network Breakdown :   네트워크별 TX 건수, 가스, 비용
Gas by Operation Type : 타입별 건수, TX당 가스, 총 가스, 비율
Recent Transactions :  최근 트랜잭션 목록 (Hash, Type, From, To, Value, Est. Gas, Network, Time)`,
    lbank: `<b>[페이지 설명]</b>
LBank 거래소 실시간 거래 관리 페이지입니다.
오더북(매도/매수), 봇 제어, 수동 주문, LP별 물량 확인이 가능합니다.
SSE(Server-Sent Events) 기반 실시간 데이터 업데이트를 지원합니다.

<b>[구성 컴포넌트]</b>
LBankPriceHeader : 현재가, 24시간 변동률, 환율, 스프레드 표시
LBankBotControls : 봇 활성화, 하한가/상한가 설정, 거래량 조절
LBankOrderBook :   매도/매수 오더북, LP별 물량 표시, 수동 주문

<b>[봇 제어]</b>
봇 실행/중단 :  자전거래 봇 활성화 토글
Price Floor :   봇 하한 가격 설정
Price Ceiling : 봇 상한 가격 설정
거래량 :        봇 거래량 비율(%) 조절

<b>[오더북]</b>
LP1/LP2/LP3 : 각 LP 계정의 주문 수량
개미물량 :     총수량 - LP 합계 (외부 물량)
cancel :       특정 가격대 주문 취소
clear :        물량 소진 주문`,
    lbankAssetChanges: `<b>[페이지 설명]</b>
LBank 자산 변동(Asset Changes) 내역을 조회하는 페이지입니다.
MM봇 Leak과 수동 주문(Manual Order)에 의한 자산 변동을 통합하여 표시합니다.
기간별, Side, Source 필터 및 CSV 다운로드를 지원합니다.

<b>[Column Description]</b>
Source :       변동 출처 (mm_bot: 보라색, manual: 회색)
Side :         매수/매도 (buy: 녹색, sell: 빨강)
Price :        거래 가격
Quantity :     거래 수량
USDT Change :  USDT 변동량 (양수: 녹색, 음수: 빨강)
METAQ Change : METAQ 변동량 (양수: 녹색, 음수: 빨강)
Time :         발생 시간

<b>[Stats Summary]</b>
Total Changes :     총 변동 건수
Total USDT Change : USDT 총 변동량
Total METAQ Change : METAQ 총 변동량

<b>[데이터 소스]</b>
* mm_bot : lbank_trade_logs에서 Leak 발생 건 (usdtDiff, metaqDiff)
* manual : lbank_trades에서 체결(filled) 주문 건`,
    lbankLosses: `<b>[페이지 설명]</b>
LBank 거래소 손실(Losses) 내역을 조회하는 페이지입니다.
기간별, 손실 유형(Loss Type) 필터와 손실 통계, 일별 통계를 제공합니다.
CSV 다운로드 및 컬럼 설정이 가능합니다.

<b>[Column Description]</b>
ID :         손실 기록 ID
Loss (USDT) : 손실 금액 (USDT, 빨강 표시)
Price :      거래 가격
Quantity :   거래 수량
Before :     거래 전 총 USDT 자산
After :      거래 후 총 USDT 자산
Type :       손실 유형 (external_fill, partial_fill)
Detail :     LP별 잔고 변동 상세 (툴팁)
Created At : 발생 시간

<b>[Stats Summary]</b>
Total Loss Count : 총 손실 건수
Total Loss (USDT) : 총 손실 금액

<b>[Daily Loss Statistics]</b>
Date / Loss Count / Total Loss (USDT)`,
    lbankMonitor: `<b>[페이지 설명]</b>
LBank 거래소 모니터링 대시보드입니다.
당일 거래 요약(거래수, Leak수, Leak수량, 총손실)과 탭별 상세 정보를 제공합니다.
10초 간격 자동 갱신됩니다.

<b>[Summary Cards]</b>
Today Trades :  당일 총 거래 건수
Today Leaks :   당일 Leak(유출) 건수
Leak Quantity : 당일 Leak 수량 (METAQ)
Total Loss :    당일 총 손실 (USDT)

<b>[Tabs]</b>
Bot Trades :      봇 거래 내역
Manual Orders :   수동 주문 내역
Balance History : 잔고 이력
Daily Stats :     일별 통계
Profit Report :   수익 리포트`,
    lbankOrderHistory: `<b>[페이지 설명]</b>
LBank 거래소의 주문 이력(Order History)을 LP 계정별로 조회하는 페이지입니다.
LP1, LP2, LP3 세 개 계정의 최근 300건 주문 내역을 시간순으로 표시합니다.

<b>[Column Description]</b>
time :               주문 시간
limit_price :        주문 가격
status :             주문 상태
side :               주문 방향 (buy/sell)
quantity :           주문 수량
cancelled_quantity : 취소 수량
filled_quantity :    체결 수량`,
    lbankSchedule: `<b>[페이지 설명]</b>
LBank 봇 스케줄 관리 페이지입니다.
요일별 봇 운영 시간을 설정하고, 프리셋을 적용하며, 주간 운영 현황을 시각화합니다.
서버 및 localStorage에 저장됩니다.

<b>[기능]</b>
스케줄 활성화/비활성화 : 전체 스케줄 토글
요일별 시작/종료 시간 : 각 요일 운영 시간 설정
Quick Presets :
  - 평일 9-18시 : 월~금 09:00~18:00
  - 평일 24시간 : 월~금 00:00~23:59
  - 매일 24시간 : 월~일 00:00~23:59
  - 초기화 :      모든 요일 비활성화

<b>[Weekly Overview]</b>
요일별 운영 시간을 가로 막대 차트로 시각화합니다.

<b>[주의사항]</b>
* 시간대(Timezone)는 브라우저의 로컬 시간대를 기준으로 합니다.
* 저장 실패 시 localStorage에만 저장됩니다.`,
    lbankTradeLogs: `<b>[페이지 설명]</b>
LBank 봇 거래 로그(Trade Logs)를 조회하는 페이지입니다.
자전거래 봇의 실행 이력, Leak 발생 여부, 실행 시간 등을 상세하게 확인합니다.
기간별, Trade Type, Leak 필터와 일별 통계를 제공합니다.

<b>[Column Description]</b>
ID :          로그 ID
Type :        거래 유형 (sell_side: 빨강, buy_side: 녹색)
Price :       거래 가격
Quantity :    거래 수량
Spread :      매도-매수 스프레드
Status :      Leak 여부 (LEAK: 빨강, OK: 녹색)
Leak Qty :    Leak 수량 (Leak 발생 시만 표시)
Exec Time :   실행 시간 (ms)
Balance :     잔고 변동 상세 (Before/After/Diff, 툴팁)
Orders :      주문 상세 (Order1/Order2 성공 여부, 툴팁)
Created At :  발생 시간

<b>[Stats Summary]</b>
Total Trades :      총 거래 건수
Total Leaks :       총 Leak 건수
Leak Quantity :     총 Leak 수량 (METAQ)
Avg Execution Time : 평균 실행 시간 (ms)

<b>[Daily Trade Statistics]</b>
Date / Total Trades / Leak Count / Leak Quantity / Avg Exec Time`,
    lbankTrades: `<b>[페이지 설명]</b>
LBank 거래소 체결(Trades) 내역을 조회하는 페이지입니다.
기간별, Side(buy/sell) 필터와 통계 요약, 일별 통계를 제공합니다.
CSV 다운로드 및 컬럼 설정이 가능합니다.

<b>[Column Description]</b>
ID :         거래 ID
Exchange :   거래소명
Symbol :     거래 심볼
Side :       매수/매도 (buy: 녹색, sell: 빨강)
Price :      체결 가격
Quantity :   체결 수량
Amount :     체결 금액 (USDT)
Order ID :   주문 ID (복사 가능)
Status :     주문 상태
Created At : 체결 시간

<b>[Stats Summary]</b>
Total Trades :   총 거래 건수
Total Amount :   총 거래 금액 (USDT)
Total Quantity : 총 거래 수량

<b>[Daily Statistics]</b>
Date / Trade Count / Total Amount / Total Quantity`,
    oldToken: `<b>[페이지 설명]</b>
구(Old) 토큰 보유자 목록을 조회하는 페이지입니다.
이전 버전 토큰의 지갑 주소별 METAQ, AQUA 보유량을 확인할 수 있습니다.
API 엔드포인트: /metaplanet_token/list_oldtoken

<b>[Column Description]</b>
wallet : 지갑 주소 (복사, 필터 기능)
metaq :  METAQ 보유량
aqua :   AQUA 보유량

<b>[상단 요약]</b>
METAQ : 전체 METAQ 보유량 합계
AQUA :  전체 AQUA 보유량 합계`,
    presale: `<b>[사용 방법]</b>
1. CSV 파일 업로드 또는 등록 대화상자로 프리세일 참여자를 등록합니다.
2. 등록 시 총 METAQ를 10등분하여 1개월 간격으로 10개 언락 일정이 자동 생성됩니다.
3. 행 클릭으로 상세 언락 일정(Allow Date, 수령 여부)을 확인할 수 있습니다.

<b>[Column Description]</b>
Address :       참여자 지갑 주소
Total METAQ :   할당된 총 METAQ 수량
Description :   참여자 설명/이름 (편집 가능)
Type :          프리세일 유형 — presale, advisor, private (편집 가능)
Register Date : 등록 일시
Allow Date :    언락 기간 (첫 번째 ~ 마지막 Allow Date)
Receipt :       수령 현황 (수령 건수 / 전체 건수)
Action :        삭제 (미수령 상태일 때만 가능)

<b>[File Upload Format]</b>
CSV 파일 (구분자: 콤마), 5개 필드 필수
# address, description, type, metaq, unlockDate
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877,홍길동,presale,10000,2024-12-25
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877,홍길동,advisor,10000,2024-12-25

<b>[Registration Dialog]</b>
Address :     참여자 지갑 주소
Description : 참여자 설명
Type :        presale / advisor / private
METAQ :       총 배분량 (10등분되어 월별 언락)
Allow Date :  첫 번째 언락 시작 날짜

<b>[주의사항]</b>
* 등록 시 METAQ는 10등분되어 1개월 간격 10개 일정으로 자동 분할됩니다.
* 이미 수령된 항목이 있는 그룹은 삭제할 수 없습니다.
* Allow Date 변경은 미수령 그룹에서만 가능하며, 변경 시 1개월 간격으로 재설정됩니다.
* "전체 삭제"는 미수령 항목만 삭제합니다.`,
    probit: `<b>[페이지 설명]</b>
Probit 거래소 실시간 거래 관리 페이지입니다.
오더북(매도/매수), 봇 제어, 수동 주문, LP별 물량 확인이 가능합니다.
1초 간격으로 자동 갱신됩니다.

<b>[상단 가격 정보]</b>
Probit :  Probit 거래소 현재가 및 24시간 변동률
LBank :   LBank 거래소 현재가 및 24시간 변동률
Price :   현재가 x 환율(KRW) 환산 가격
Spread :  매도 최저가 - 매수 최고가

<b>[봇 제어]</b>
봇 실행/중단 :  자전거래 봇 활성화 토글
기본가격 :      봇 기준 가격 설정
제한가격 :      봇 제한 가격 설정
거래량 :        봇 거래량 비율(%) 슬라이더

<b>[오더북 Column]</b>
가격 :         주문 가격
수량 :         총 수량
LP1/LP2/LP3 :  각 LP 계정의 주문 수량 (잔여/원래수량)
개미물량 :     총수량 - LP 합계 (외부 물량)
비용예측(KWR) : 개미물량 x 가격 x 환율`,
    probitDeposit: `<b>[페이지 설명]</b>
Probit 거래소 입출금(Deposit) 내역을 조회하는 페이지입니다.
특정 입금 주소(0x898F...)의 ERC-20 토큰 전송 이력을 기간별로 조회합니다.
주소 이름/유형 편집 및 CSV 다운로드가 가능합니다.

<b>[Column Description]</b>
Block Number :     블록 번호
Transaction Hash : 트랜잭션 해시 (복사, 탐색기 링크)
Time :             전송 시간
From :             보낸 주소 (이름 편집, 복사, 탐색기 링크)
To :               받는 주소 (이름 편집, 복사, 탐색기 링크)
Value :            전송 수량

<b>[주소 유형]</b>
Default, Company, Exchange, Marketing, Sale, Staking,
Team, CM liquidity, Advisor, Unlock, Portal, System

<b>[참고]</b>
* 시스템 지갑 주소는 녹색으로 표시됩니다.
* Total 영역에 전체 건수 및 총 전송량이 표시됩니다.`,
    probitOrderHistory: `<b>[페이지 설명]</b>
Probit 거래소의 주문 이력(Order History)을 LP 계정별로 조회하는 페이지입니다.
LP1, LP2, LP3 세 개 계정의 최근 300건 주문 내역을 시간순으로 표시합니다.

<b>[Column Description]</b>
time :               주문 시간
limit_price :        주문 가격
status :             주문 상태
side :               주문 방향 (buy/sell)
quantity :           주문 수량
cancelled_quantity : 취소 수량
filled_quantity :    체결 수량`,
    report: `<b>[페이지 설명]</b>
리포트 생성기 페이지입니다.
다양한 리포트 유형을 선택하고 기간을 설정하여 데이터를 미리보기 및 내보내기합니다.
CSV, Excel, PDF 형식으로 내보내기가 가능합니다.

<b>[필터]</b>
Report Type : REPORT_TYPES 상수에 정의된 리포트 유형 목록
From Date :   시작 날짜
To Date :     종료 날짜
Period :      빠른 기간 선택 (7일, 30일, 90일, Custom)

<b>[기능]</b>
Preview :  선택한 리포트 데이터 미리보기 (테이블 표시)
Export :   CSV / Excel / PDF 형식으로 내보내기
           대용량 데이터는 페이지 단위 다운로드 (progress bar 표시)

<b>[참고]</b>
* 리포트 유형별 헤더, 컬럼, API 엔드포인트는 reportConfig.js에 정의됩니다.
* 대용량 리포트(useLargeExport)는 서버 페이지네이션을 사용합니다.`,
    token: `<b>[페이지 설명]</b>
토큰 보유자 목록을 조회하는 페이지입니다.
지갑 주소별 METAQ, AQUA 보유량과 전체 합계를 확인할 수 있습니다.

<b>[Column Description]</b>
wallet : 지갑 주소 (복사, 탐색기 링크, 필터 기능)
metaq :  METAQ 보유량
aqua :   AQUA 보유량

<b>[상단 요약]</b>
METAQ : 전체 METAQ 보유량 합계
AQUA :  전체 AQUA 보유량 합계`,
  },
  settings: {
    account: `<b>[페이지 설명]</b>
관리자 계정(Address)을 등록/수정/조회하는 페이지입니다.
검색, CSV 다운로드, 블록체인 익스플로러 연결 기능을 제공합니다.

<b>[Column Description]</b>
Address :      계정 지갑 주소
Description :  계정 설명
Enabled :      활성화 여부 (체크박스)
Edit :         수정 버튼

<b>[기능]</b>
- Add : 새 계정 등록 (stage 3)
- Edit : 계정 정보 수정 (stage 2)
- Copy : 주소 클립보드 복사
- Explorer : 블록체인 익스플로러에서 주소 조회
- Download CSV : 전체 계정 목록 CSV 다운로드`,
    apiKeys: `<b>[페이지 설명]</b>
API Key를 생성/수정/삭제/조회하는 페이지입니다.
발급자(Issuer)별로 ERC20/721/1155 컨트랙트 주소를 매핑합니다.
만료 관리 기능이 포함되어 있으며, 색상 코드 상태 표시기와 갱신 알림을 제공합니다.

<b>[Column Description]</b>
ISSUER :          API Key 발급자
API Key :         발급된 API Key 값
ERC20 Address :   ERC20 컨트랙트 주소
ERC721 Address :  ERC721 컨트랙트 주소
ERC1155 Address : ERC1155 컨트랙트 주소
Expires At :      API Key 만료일 (색상 코드: 초록 30일 이상, 노랑 7-30일, 빨강 7일 미만, 회색 만료 없음)
Modified Date :   수정일
Created Date :    생성일

<b>[만료 기능]</b>
만료일 설정 :     API Key의 만료일을 설정하거나 제거
갱신 :            만료일을 연장하거나 API Key를 재생성
필터 :            만료 임박 키만 표시하는 토글
경고 배너 :       7일 이내 만료 예정 키가 있을 때 표시`,
    apiStats: `<b>[페이지 설명]</b>
전체 API 호출 통계를 조회하는 페이지입니다.
기간별/시간별 API 호출량, 에러율, 응답 시간을 분석합니다.

<b>[요약 카드]</b>
Total Calls :    총 API 호출 수
Total Errors :   총 에러 수
Error Rate :     에러율 (%)
Avg Response :   평균 응답 시간 (ms)

<b>[차트]</b>
Call Volume :    기간별 호출/에러 건수 (Bar Chart)
Response Time :  기간별 평균 응답 시간 (Line Chart)

<b>[Top Methods / Top Errors 테이블]</b>
Method :  API 메서드명
Calls :   호출 수
Errors :  에러 수
Avg Ms :  평균 응답 시간`,
    auditLog: `<b>[페이지 설명]</b>
관리자 활동 로그를 조회하는 페이지입니다.
API 호출 기록, 성공/실패 여부, 응답 시간 등을 확인할 수 있습니다.
행 클릭 시 설정 변경 이전/이후 값을 JSON Diff로 비교할 수 있습니다.

<b>[Column Description]</b>
Time :         API 호출 시각 (UTC)
Address :      호출자 지갑 주소
Method :       호출된 API 메서드명
Client IP :    클라이언트 IP 주소
Duration(ms) : API 응답 소요 시간 (밀리초)
Success :      성공(OK) / 실패(FAIL) 여부
Error :        에러 메시지 (실패 시)

<b>[필터]</b>
- Search Address : 주소 검색
- Action Type : API 카테고리 필터 (account, permission, role 등)
- Date Range : 기간 검색
- Export : CSV / Excel / PDF 다운로드`,
    contractDeploy: `<b>[페이지 설명]</b>
스마트 컨트랙트를 배포하는 페이지입니다.
Stepper UI로 체인 선택 > 토큰 타입 > 파라미터 입력 > 배포 순서로 진행합니다.
배포 완료 후 자동으로 network_info에 등록하고 히스토리를 저장합니다.

<b>[배포 절차]</b>
Step 1 : 체인 선택 (Mainnet/Testnet)
Step 2 : 토큰 타입 선택 (ERC20/ERC721/ERC1155) + 옵션
Step 3 : 파라미터 입력 (Name, Symbol 등)
Step 4 : 리뷰 및 배포 (MetaMask 서명)

<b>[배포 결과]</b>
Contract Address :     배포된 컨트랙트 주소
TX Hash :              트랜잭션 해시
Block :                블록 번호
Registration :         네트워크 자동 등록 상태`,
    deployHistory: `<b>[페이지 설명]</b>
스마트 컨트랙트 배포 이력을 조회하는 페이지입니다.
배포된 컨트랙트 정보, 트랜잭션 해시, 등록 상태 등을 확인합니다.

<b>[Column Description]</b>
Created At :        배포 일시
Chain :             체인 ID
Token Type :        토큰 타입 (ERC20/ERC721/ERC1155)
Options :           배포 옵션 (Mintable, Burnable 등)
Token Name :        토큰명
Symbol :            토큰 심볼
Contract Address :  컨트랙트 주소
Deployer :          배포자 주소
TX :                트랜잭션 해시
Status :            배포 상태 (success/fail)
Registration :      네트워크 등록 상태 (success/failed, 재시도 가능)`,
    group: `<b>[페이지 설명]</b>
사용자 그룹을 관리하는 페이지입니다.
그룹 생성/수정/삭제 및 역할(Role) 할당 기능을 제공합니다.
시스템 그룹(Admin, Operator, Viewer)은 삭제할 수 없습니다.

<b>[Column Description]</b>
ID :          그룹 고유 ID
Name :        그룹명
Description : 그룹 설명
Roles :       할당된 역할 수
Members :     그룹 소속 멤버 수
Status :      활성/비활성 상태
Actions :     수정, 역할 할당, 삭제 버튼`,
    healthCheck: `<b>[페이지 설명]</b>
시스템 헬스 체크 상태를 확인하는 페이지입니다.
30초 간격 자동 갱신으로 서비스 상태를 실시간 모니터링합니다.
자동 갱신 On/Off 전환 및 "지금 확인" 버튼으로 즉시 상태 확인이 가능합니다.

<b>[전체 상태 배너]</b>
전체 시스템 상태를 색상으로 표시합니다.
녹색 = 모든 서비스 정상 / 주황색 = 일부 경고 / 빨간색 = 장애 발생

<b>[요약 카드]</b>
Uptime :       서버 가동 시간
Memory :       메모리 사용량 (Alloc MB / Sys MB)
Goroutines :   Go 루틴 수
Services :     정상/전체 서비스 수

<b>[서비스 상태 카드]</b>
MySQL (Metaplanet, Skyplay, Portal) : 각 DB 연결 상태 및 응답 시간
MongoDB :    MongoDB 연결 상태
Redis :      Redis 연결 상태
API Server : API 서버 자체 응답
Disk Space : 디스크 사용량 (90% 이상 시 경고)

<b>[상태 이력]</b>
최근 50건의 상태 확인 이력을 표시합니다.
상태 변화 시 (정상 → 비정상) 알림이 표시됩니다.`,
    ipWhitelist: `<b>[페이지 설명]</b>
IP 화이트리스트를 관리하는 페이지입니다.
허용된 IP에서만 관리자 접속이 가능하도록 제한합니다.

<b>[Column Description]</b>
IP Address :  허용할 IP 주소
Description : IP 설명 (사무실, VPN 등)
Active :      개별 IP 활성/비활성 토글
Created At :  등록일시
Actions :     삭제 버튼

<b>[주의사항]</b>
- 화이트리스트 활성화 시 현재 접속 IP가 포함되지 않으면 자동 차단됨
- Self-lock 경고 표시로 실수 방지`,
    loginHistory: `<b>[페이지 설명]</b>
관리자 로그인 이력을 조회하는 페이지입니다.
로그인 성공/실패 기록, 접속 IP, 브라우저 정보를 확인할 수 있습니다.

<b>[Column Description]</b>
Time :           로그인 시도 시각 (UTC)
Address :        로그인 시도 지갑 주소
Client IP :      클라이언트 IP 주소
User Agent :     브라우저/OS 정보
Success :        성공(OK) / 실패(FAIL) 여부
Failure Reason : 로그인 실패 사유

<b>[필터]</b>
- Search Address : 주소 검색
- Date Range : 기간 검색
- Download CSV : 로그인 이력 CSV 다운로드`,
    network: `<b>[Column Description]</b>
ChainID :             네트워크 식별자 — 1(Ethereum), 56(BSC), 137(Polygon), 80001(Polygon Testnet)
Address :             스마트 컨트랙트 주소 (토큰 배포 주소)
TokenType :           컨트랙트 타입 — erc20(토큰), erc721(NFT), erc1155(멀티토큰)
Name :                토큰/컨트랙트 이름
Symbol :              토큰 심볼 (예: METAQ, USDT)
BlockNumber :         마지막으로 스캔된 블록 번호
Initial Block Number: 스캔 시작 블록 번호 (컨트랙트 배포 시점 등)

<b>[Process Status]</b>
<b>Scan</b>
  Tx (Transaction) :  트랜잭션 스캔 — 토큰 이동 내역 수집
  Vol (Volume) :      거래량 스캔 — 거래량 데이터 집계
  Dep (Deposit) :     입금 스캔 — 입금 트랜잭션 감지
  SW (Platform Wallet) : 플랫폼 지갑 스캔 — 시스템 지갑 잔액 모니터링
  HB (Holder Balance) :  홀더 잔액 조회 — 토큰 보유자 잔액 업데이트
  FT (Flush Token) :  토큰 수집 — 분산된 토큰을 시스템 지갑으로 회수

<b>Transfer</b>
  WD (Withdraw) :     출금 처리 — 사용자 출금 요청 실행
  WS (Withdraw Status) : 출금 상태 확인 — 출금 트랜잭션 컨펌 추적
  AD (Airdrop) :      에어드롭 전송 — 대량 토큰 분배 실행
  AS (Airdrop Status) :  에어드롭 상태 확인 — 에어드롭 트랜잭션 컨펌 추적
  MT (Minting) :      민팅 처리 — NFT/토큰 발행
  MS (Minting Status) :  민팅 상태 확인 — 민팅 트랜잭션 컨펌 추적

<b>State</b>
  Init (Initialized) : 초기화 상태 — 네트워크 초기 설정 완료 여부

● 녹색: 프로세스 실행 중  ● 회색: 프로세스 중지`,
    notificationPreferences: `<b>[페이지 설명]</b>
알림 채널별 수신 설정을 관리하는 페이지입니다.
알림 카테고리별로 인앱/텔레그램/이메일 수신 여부를 개별 설정합니다.
설정값은 서버에 저장되며, 서버 연결 불가 시 localStorage에 캐시됩니다.

<b>[알림 카테고리]</b>
Trading Alert :      봇 거래 활동, 주문 체결, 거래 오류
Price Alert :        임계값 초과 토큰 가격 변동
System Alert :       시스템 오류, 다운타임, 점검
Security Alert :     로그인 시도, 2FA 변경, 의심스러운 활동
Withdrawal Alert :   출금 요청 및 완료

<b>[채널]</b>
In-App :    인앱 알림 (항상 사용 가능)
Telegram :  텔레그램 봇 알림
Email :     이메일 알림 (SMTP)

<b>[채널 개요]</b>
각 채널의 상태와 활성 카테고리 수를 한눈에 확인할 수 있습니다.
채널 마스터 스위치를 사용하여 해당 채널의 모든 카테고리를 일괄 활성화/비활성화합니다.

<b>[방해 금지 시간]</b>
지정된 시간대에 텔레그램 및 이메일 알림을 중단합니다.
인앱 알림은 방해 금지 시간에 영향을 받지 않습니다.

<b>[빠른 설정]</b>
전체 활성화 :      모든 카테고리의 모든 채널 활성화
전체 비활성화 :    모든 카테고리의 모든 채널 비활성화
인앱만 :           인앱만 활성화, 텔레그램/이메일 비활성화
텔레그램만 :       텔레그램만 활성화, 인앱/이메일 비활성화
이메일만 :         이메일만 활성화, 인앱/텔레그램 비활성화
기본값 복원 :      기본 설정으로 복원`,
    permissionCode: `<b>[페이지 설명]</b>
시스템에 등록된 권한 코드(Permission Code) 목록을 조회하는 페이지입니다.
API 엔드포인트별 접근 레벨과 카테고리를 확인할 수 있습니다.

<b>[Column Description]</b>
FullMethod :    gRPC 메서드 전체 경로
Route :         연결된 프론트엔드 라우트
Name :          권한 표시명
Category :      카테고리 (account, wallet, lbank 등)
Access Level :  접근 레벨 (public, authenticated, protected)`,
    preferences: `<b>[페이지 설명]</b>
사용자 환경설정을 관리하는 페이지입니다.
테이블 표시 개수, 기본 날짜 범위, 정렬 설정 등을 저장합니다.
설정값은 localStorage에 저장되어 브라우저별로 유지됩니다.

<b>[설정 항목]</b>
Default Items Per Page : 테이블 기본 표시 행 수 (5/10/20/50/100)
Default Date Range :     날짜 필터 기본 기간 (3/7/14/30/90일)
Saved Table Sort :       뷰별 저장된 정렬 설정 목록
Reset All Preferences :  모든 설정 초기화`,
    role: `<b>[페이지 설명]</b>
역할(Role)을 관리하는 페이지입니다.
역할 생성/수정/삭제 및 권한(Permission) 할당 기능을 제공합니다.
메뉴 그룹별로 Viewer/Operator 권한을 일괄 또는 개별 설정할 수 있습니다.
시스템 역할(SUPER_ADMIN, ADMIN, OPERATOR, VIEWER)은 삭제할 수 없습니다.

<b>[Column Description]</b>
ID :          역할 고유 ID
Name :        역할명
Description : 역할 설명
Level :       권한 레벨 (높을수록 상위 권한)
Groups :      해당 역할이 할당된 그룹 수
Permissions : 할당된 권한 수
Status :      활성/비활성 상태
Actions :     수정, 권한 관리, 삭제 버튼`,
    sessionManagement: `<b>[페이지 설명]</b>
활성 세션을 관리하는 페이지입니다.
현재 로그인된 모든 세션을 확인하고, 다른 기기의 세션을 해제할 수 있습니다.

<b>[세션 정보]</b>
Browser :       브라우저 종류 (Chrome, Firefox, Edge 등)
IP Address :    접속 IP 주소
Login Time :    로그인 시각
Last Activity : 마지막 활동 시각
Expires At :    세션 만료 시각
User Agent :    브라우저/OS 상세 정보

<b>[기능]</b>
- Current 표시 : 현재 접속 중인 세션 (녹색 테두리)
- Revoke : 개별 세션 해제
- Revoke All Others : 현재 세션 외 모든 세션 일괄 해제`,
    systemWallet: `<b>[Column Description]</b>
Address :          시스템 핫 월렛 주소 (자동 생성된 블록체인 계정)
Description :      지갑 용도 설명 (편집 가능)
Contract Address : 연결된 토큰 컨트랙트 주소
Token Type :       컨트랙트 타입 (erc20, erc721, erc1155)
Balance :          네이티브 토큰 잔액 (Gas Fee용, 예: MATIC, BNB)
Quantity :         해당 컨트랙트 토큰 보유량

<b>[Actions]</b>
Create Wallet :    새 핫 월렛 계정 생성 (Description 입력 후 Generate)
Enabled :          지갑 활성화/비활성화 — 비활성화 시 출금/에어드롭 발송 지갑에서 제외
Description 편집 : 지갑 설명 수정 (Description 컬럼 hover → 연필 아이콘)
Sum :              현재 조회된 전체 지갑의 토큰 보유량 합계`,
    thresholdSetting: `<b>[페이지 설명]</b>
시스템 임계값(Threshold)을 설정하는 페이지입니다.
출금 한도, 가격 변동 알림, 잔액 유지 기준을 설정합니다.

<b>[설정 항목]</b>
Withdrawal Limit :
  - Single Limit : 1회 출금 한도
  - Daily Limit :  일일 출금 한도

Price Volatility Alert :
  - Price Change % :      가격 변동 알림 비율 (기본 5%)
  - Monitor Interval :    모니터링 주기 (분)

Balance Maintenance :
  - Min Balance :     최소 잔액 기준
  - Warning Balance : 잔액 경고 기준`,
    twoFASetting: `<b>[페이지 설명]</b>
2단계 인증(2FA/TOTP)을 설정하는 페이지입니다.
Google Authenticator 등 TOTP 앱과 연동하여 로그인 보안을 강화합니다.

<b>[절차]</b>
1. Setup : QR 코드 스캔 또는 시크릿 키 수동 입력
2. Verify : 6자리 인증 코드 입력하여 활성화
3. Backup : 백업 코드 저장 (분실 시 복구용)
4. Disable : 인증 코드 입력 후 비활성화 가능`,
    webauthn: `<b>[페이지 설명]</b>
WebAuthn/FIDO2 하드웨어 보안 키를 관리하는 페이지입니다.
YubiKey와 같은 키를 등록하여 피싱 방지, 패스워드 없는 인증을 사용할 수 있습니다.

<b>[기능]</b>
키 등록 :           새 하드웨어 보안 키 등록 (크로스 플랫폼 인증자)
키 이름 :           등록 후 식별을 위한 이름 지정
등록된 키 :         등록일과 함께 모든 보안 키 목록 조회
키 삭제 :           등록된 키 삭제 (확인 대화상자 포함)
브라우저 확인 :     자동 브라우저 호환성 감지

<b>[작동 방식]</b>
1. "보안 키 등록" 클릭하여 WebAuthn 등록 흐름 시작
2. 브라우저 프롬프트에 따라 하드웨어 보안 키 삽입 및 터치
3. 선택적으로 키에 이름 지정 (예: "사무실 YubiKey", "백업 키")
4. 키가 저장되어 로그인 시 인증에 사용 가능

<b>[로그인 통합]</b>
비밀번호/2FA 입력 후 "보안 키 사용" 옵션이 제공됩니다.
TOTP 코드 입력 없이 키를 삽입하고 터치하여 인증할 수 있습니다.

<b>[참고사항]</b>
* WebAuthn을 지원하는 최신 브라우저 필요 (Chrome, Firefox, Safari, Edge)
* 크로스 플랫폼 인증자 사용 (USB/NFC 보안 키)
* 챌린지-응답 기반: 개인 키는 하드웨어 장치를 절대 떠나지 않음
* 백업 목적으로 여러 키 등록 가능`,
    withdrawStats: `<b>[페이지 설명]</b>
출금 통계 대시보드입니다. 출금 건수, 금액, 처리 시간, 거절률을 분석합니다.
이전 기간과 비교하여 추이를 확인할 수 있습니다.

<b>[요약 카드]</b>
총 출금 건수 :     기간 내 총 출금 요청 건수
총 출금 금액 :     기간 내 총 출금 금액
평균 처리시간 :    요청에서 완료까지 평균 소요 시간
거절률 :           거절된 출금의 비율 (%)
각 카드는 동일 길이의 이전 기간 대비 변화율을 표시합니다.

<b>[차트]</b>
상태별 분포 :      출금 상태별 분포 (도넛 차트)
일별 출금 추이 :   일별 건수(막대) 및 금액(선) 이중 축 차트
처리 시간 추이 :   기간별 평균 처리 시간 변화 (선 차트)
거절률 추이 :      기간별 거절률 변화 (선 차트)

<b>[상태별 상세 테이블]</b>
상태 :     출금 상태 (대기, 완료, 실패, 거절, 블랙리스트)
건수 :     상태별 출금 건수
금액 :     상태별 총 금액
비율 :     각 상태의 비중`,
    anomalyDetection: `<b>[페이지 설명]</b>
트랜잭션 이상 탐지는 비정상적인 트랜잭션 패턴을 자동으로 모니터링합니다.
탐지 규칙을 설정하고, 발생한 알림을 확인하고, 검토된 이상을 확인 처리할 수 있습니다.
요약 카드를 통해 활성 알림 및 심각도 분포를 한눈에 파악할 수 있습니다.

<b>[탐지 규칙]</b>
MASS_WITHDRAWAL :    동일 주소에서 M분 내 N건 이상 출금
REPEATED_FAILURE :   N건 이상 연속 트랜잭션 실패
UNUSUAL_AMOUNT :     평균 대비 N 표준편차 초과 금액
RAPID_TRANSFERS :    M분 내 N건 이상 전송
NEW_ADDRESS_LARGE :  처음 보는 주소로 대규모 전송

<b>[알림 심각도]</b>
Critical (빨강) :    즉각적인 주의가 필요함
Warning (노랑) :     잠재적인 문제 감지됨
Info (파랑) :        정보성 알림

<b>[요약 카드]</b>
활성 알림 :         확인되지 않은 알림 수
오늘 확인됨 :       오늘 확인 처리된 알림 수
가장 빈번한 유형 :  가장 많이 발생한 규칙 유형
심각도 분포 :       Critical / Warning / Info 알림 수

<b>[기능]</b>
- 개별 탐지 규칙 활성화/비활성화
- 규칙 매개변수 설정 (임계값, 시간 범위)
- 규칙 유형, 심각도, 상태별 알림 필터링
- 알림 확인 처리 (검토 완료 표시)
- 30초마다 자동 갱신`,
    walletMonitor: `<b>[페이지 설명]</b>
시스템 지갑 잔액을 모니터링하고 저잔액 알림을 설정하는 페이지입니다.
현재 잔액, 24시간 변동률, 색상 코딩된 알림 상태를 표시합니다.

<b>[지갑 카드]</b>
Address :       지갑 주소 (축약)
Balance :       현재 토큰 잔액
24h Change :    최근 24시간 잔액 변동률
USD Value :     추정 USD 가치
Threshold :     설정된 최소 잔액 임계값
Status :        정상 (녹색) / 경고 (노란색, 임계값 2배 미만) / 위험 (빨간색, 임계값 미만)

<b>[잔액 이력 차트]</b>
- 선택한 지갑의 시간별 잔액 라인 차트
- 기간 필터: 7일, 30일, 90일
- 임계선: 위험 (빨간 점선), 경고 (주황 점선)

<b>[알림 설정 테이블]</b>
Wallet Address : 모니터링 대상 지갑 주소
Network :        블록체인 네트워크
Token :          토큰 심볼
Min Balance :    최소 잔액 임계값
Channels :       알림 채널 (인앱, 텔레그램, 이메일)
Enabled :        알림 활성화 상태
Actions :        수정 / 삭제

<b>[기능]</b>
- 60초마다 자동 갱신
- 지갑 카드 클릭 시 잔액 이력 차트 표시
- 지갑별 알림 설정 추가/수정/삭제
- 다중 채널 알림 지원 (인앱, 텔레그램, 이메일)`,
    priceAlert: `<b>[페이지 설명]</b>
다중 알림 채널을 통한 자동 토큰 가격 알림을 설정합니다.
가격 상한/하한 또는 비율 변동 조건을 설정할 수 있습니다.

<b>[알림 조건]</b>
가격 이상 :       가격이 지정한 USD 값 이상으로 오르면 발동
가격 이하 :       가격이 지정한 USD 값 이하로 내려가면 발동
변동률 % :        가격이 지정한 비율 이상 변동하면 발동

<b>[알림 채널]</b>
인앱 :            알림 센터에 표시
텔레그램 :        텔레그램 봇으로 알림 전송
이메일 :          이메일로 알림 전송

<b>[빠른 설정]</b>
+5% / +10% / -5% / -10% : 비율 변동 알림 빠른 생성

<b>[기능]</b>
- 토글 스위치로 개별 알림 활성화/비활성화
- 발동 횟수 및 마지막 발동 시간 확인
- 알림별 필터링이 가능한 알림 이력
- 알림당 다중 알림 채널 설정`,
    backupMonitor: `<b>[페이지 설명]</b>
MySQL 및 MongoDB 백업 상태를 모니터링하는 페이지입니다.
백업 상태, 이력을 확인하고 수동 백업 실행 및 설정 변경이 가능합니다.

<b>[상태 카드]</b>
MySQL 백업 :    MySQL 백업 상태 (마지막 백업 시간, 크기, 경과 시간, 파일 수)
MongoDB 백업 :  MongoDB 백업 상태 (마지막 백업 시간, 크기, 경과 시간, 파일 수)
상태 색상 :      녹색 (정상, 24시간 미만) / 노란색 (경고, 24-48시간) / 빨간색 (위험, 48시간 이상)

<b>[백업 이력 테이블]</b>
유형 :       데이터베이스 유형 (MySQL / MongoDB)
파일명 :     백업 파일 또는 디렉토리 이름
크기 :       전체 백업 크기
백업 시간 :  백업 생성 타임스탬프
경과 :       백업 생성 후 경과 시간 (시간)
상태 :       경과 시간 기반 정상 / 경고 / 위험

<b>[백업 설정]</b>
스케줄 (Cron) :    자동 백업 스케줄 크론 표현식 (예: 0 2 * * *)
보관 기간 (일) :    정리 전 백업 파일 보관 일수
백업 경로 :         백업이 저장되는 파일시스템 경로
활성화 :            자동 스케줄 백업 활성화/비활성화

<b>[기능]</b>
- 확인 대화상자가 있는 수동 백업 트리거
- 60초마다 상태 자동 갱신
- 유형 필터가 있는 페이지네이션 백업 이력
- 데이터베이스별 백업 설정`,
  },
}
